import { useEffect, useState } from "react";
import Loader from "react-loaders";
import AnimatedLetters from "../AnimatedLetters";
import portfolioData from "../../data/portfolio.json";
import "./index.scss";

const Projects = () => {
  const [letterClass, setLetterClass] = useState("text-animate");

  useEffect(() => {
    const timer = setTimeout(() => setLetterClass("text-animate-hover"), 3000);
    return () => clearTimeout(timer);
  }, []);

  const projects = portfolioData.portfolio;

  return (
    <>
      <div className="container projects-page">
        <h1 className="page-title">
          <AnimatedLetters
            letterClass={letterClass}
            strArray={["M", "y", " ", "P", "r", "o", "j", "e", "c", "t", "s"]}
            idx={15}
          />
        </h1>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <article
              key={project.title}
              className="project-card is-visible"
              style={{ animationDelay: `${index * 0.12}s` }}
            >
              <div className="project-image">
                <img
                  src={`${process.env.PUBLIC_URL}/${project.cover}`}
                  alt={project.title}
                  loading="lazy"
                />
                <div className="image-overlay" />
              </div>
              <div className="project-body">
                <h2 className="project-title">{project.title}</h2>
                <p className="project-description">{project.description}</p>
                <a
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-link"
                >
                  Visit Live
                  <span className="arrow" aria-hidden="true">
                    &rarr;
                  </span>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
      <Loader type="pacman" />
    </>
  );
};

export default Projects;
